import type { ReactNode } from "react";
import { Nav } from "@/components/landing/Nav";
import { Footer } from "@/components/landing/Footer";

export function MarketingLayout({ children }: { children: ReactNode }) {
  return (
    <div className="flex flex-col flex-1 min-h-screen bg-background text-slate-900 dark:text-slate-100">
      <Nav />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}
